import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

type WorkSpaceSkeletonProps = {
  count?: number;
};
function WorkSpaceSkeleton({ count = 6 }: WorkSpaceSkeletonProps) {
  const NO_OF_ITEMS_ARRAY: number[] = [];

  for (let i = 1; i <= count; i++) {
    NO_OF_ITEMS_ARRAY.push(i);
  }

  return (
    <Grid container width='100%' gap={2}>
      <Box
        display={'flex'}
        gap={2}
        width={'75%'}
        justifyContent='space-between'
      >
        <Skeleton
          variant='text'
          sx={{ fontSize: '0.7rem' }}
          width='15%'
          height='1.5rem'
        />
        <Skeleton
          variant='text'
          sx={{ fontSize: '0.7rem' }}
          width='15%'
          height='1.5rem'
        />
      </Box>
      {NO_OF_ITEMS_ARRAY.map((value) => (
        <Grid
          container
          item
          md={12}
          flexWrap='nowrap'
          bgcolor='white'
          border={(theme) => `1px solid ${theme.palette.borderColor}`}
          borderRadius='10px'
          justifyContent='space-between'
          alignItems='center'
          padding={2}
          gap={2}
          key={value}
        >
          <Box sx={{ aspectRatio: 1 }}>
            <Skeleton variant='circular' height={32} sx={{ aspectRatio: 1 }} />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default WorkSpaceSkeleton;
